import { render } from "./ShortcutLink.vue?vue&type=template&id=80a5164e&scoped=true"
import script from "./ShortcutLink.vue?vue&type=script&lang=js"
export * from "./ShortcutLink.vue?vue&type=script&lang=js"

import "./ShortcutLink.vue?vue&type=style&index=0&id=80a5164e&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-80a5164e"]])

export default __exports__